<div class="spinner-container no-bg paging">
    <mat-spinner class="spiner"></mat-spinner>
</div>